/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Manage_WebhooksInputs */



/**
* | output |
* | --- |
* | "Manage Webhooks" |
*
* @param {Leveling_Perm_Manage_WebhooksInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_manage_webhooks = /** @type {((inputs?: Leveling_Perm_Manage_WebhooksInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Manage_WebhooksInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Управлять вебхуками")
	return /** @type {LocalizedString} */ ("Manage Webhooks")
});